import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import emergency from "../assets/img/HomePage/emergency.svg";
import ModalAbout from "../components/ModalAbout";
import ModalEmergency from "../components/ModalEmergency";
import { makeStyles } from "@mui/styles";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import Options from "../components/Options";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { changeTab } from "../redux/TabSlice";
import {
  getMedicalServices,
  getPoliceServices,
} from "../redux/OrganizationSlice";
import { getOrgContactList, getTitleFromAppContent, getTranslation } from "../helpers/utils";
import { trackPageView } from "../helpers/api";
import PageBackButton from "../components/PageBackButton";
import { EmergencyPhoneBadge } from "../components/EmergencyServiceIcons";
import { colors } from "../constants/theme";

const useStyles = makeStyles((theme) => ({
  bgcolor: {
    background: "#FFFFFF",
  },
  textColor: {
    color: theme.palette.emergency.main,
  },
  input: {
    "&::placeholder": {
      color: theme.palette.emergency.main,
    },
  },

  sectionbg: {
    background: theme.palette.primary.main,
  },

  sectionBgLight: {
    backgroundColor: "#FFE2E3",
  },

  emergencyBg: {
    backgroundColor: theme.palette.emergency.light,
  },

  emergencyTextBg: {
    backgroundColor: theme.palette.emergency.main,
  },

  fullScreen: {
    minHeight: "100vh",
  },
  height: {
    maxHeight: "50vh",
  },
}));

function ServicesDetail() {
  const classes = useStyles();
  const { tab } = useSelector((state) => state.tab);
  const { selLanguageId, isEnglish, langId } = useSelector((state) => state.language);
  const { selDistrictId } = useSelector((state) => state.district);
  const { policeServices, medicalServices } = useSelector(
    (state) => state.organizations
  );
  const { appContent, selectedService } = useSelector(
    (state) => state.appContent
  );
  const [emergencyTitle, setEmergencyTitle] = useState("");
  const [openAbout, setOpenAbout] = useState(false);
  const [openItem, setOpenItem] = useState(false);
  const handleOpen = () => setOpenAbout(true);
  const handleClose = () => setOpenAbout(false);
  const [items, setItems] = useState();
  const [item, setItem] = useState();
  const [filteredData, setFilteredData] = useState();
  const [searchStr] = useState("");
  const handleCloseItem = () => setOpenItem(false);
  const { selProvinceId } = useSelector((state) => state.province);
  const [tabSelect, setTabSelect] = useState("");
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    trackPageView("Emergency Service Detail", { province: selProvinceId, district: selDistrictId, language: selLanguageId });
  }, [selProvinceId, selDistrictId, selLanguageId]);

  // Helper to safely extract text from Translation objects
  const getTextFromTranslation = (translation) => {
    if (!translation) return '';
    if (typeof translation === 'string') return translation;
    if (Array.isArray(translation)) {
      const result = getTranslation(translation, langId);
      if (result && typeof result === 'string') return result;
      if (translation.length > 0 && translation[0]?.text && typeof translation[0].text === 'string') {
        return translation[0].text;
      }
      return '';
    }
    if (typeof translation === 'object' && translation.text) {
      return typeof translation.text === 'string' ? translation.text : '';
    }
    return '';
  };

  useEffect(() => {
    if (selDistrictId) {
      dispatch(getMedicalServices({ selDistrictId, langId: selLanguageId }));
      dispatch(getPoliceServices({ selDistrictId, langId: selLanguageId }));
    }
  }, [selDistrictId, selLanguageId, dispatch]);

  useEffect(() => {
    if (items) setLoading(false);
  }, [items]);

  useEffect(() => {
    let arr = [];
    items?.forEach((item) => {
      let lowerCaseSearchText = searchStr.toLowerCase();
      if (item.title.toLowerCase().includes(lowerCaseSearchText)) {
        arr.push(item);
      }
    });
    setFilteredData(arr);
  }, [searchStr, items]);

  useEffect(() => {
    if (appContent) {
      setEmergencyTitle(getTitleFromAppContent(appContent, "Emergency Services"));
    }
  }, [appContent]);

  useEffect(() => {
    if (tab === "PoliceServices") {
      setItems(policeServices);
      setFilteredData(policeServices);
    } else {
      setItems(medicalServices);
      setFilteredData(medicalServices);
    }
    if (tabSelect) {
      dispatch(changeTab(tabSelect));
    }
  }, [selLanguageId, policeServices, medicalServices, tabSelect, tab, dispatch]);

  return (
    <div
      className={`${classes.sectionBgLight} pb-40 flex flex-col`}
    >
      <div>
        <Header />
        <PageBackButton onClick={() => setTabSelect("EmergencyServices")} />
        <div className="flex-col md:flex-row flex justify-between">
          <div className=" block md:hidden mb-5">
            <Options handleOpen={handleOpen} />
          </div>
          <div className="flex mx-5 content-center mt-2 items-center">
            <img className="w-6 mr-3 mb-2" src={emergency} alt="Emergency" />
            <div className="flex flex-col md:flex-row">
              <Typography
                onClick={() => setTabSelect("EmergencyServices")}
                className="mr-3 cursor-pointer"
                color={"black"}
                variant="p"
              >
                {emergencyTitle} {">"}
              </Typography>
              <Typography className="font-bold" color={"black"} variant="p">
                {selectedService}
              </Typography>
            </div>
          </div>
          <div className=" hidden md:block">
            <Options handleOpen={handleOpen} />
          </div>
        </div>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : (
          <div>
            <div className="flex flex-col justify-center content-center items-center my-2">
              <div
                className={clsx(
                  "w-full px-5 sm:w-4/6 my-5",
                  "max-h-[min(75dvh,720px)] overflow-y-auto overscroll-contain lg:max-h-none lg:overflow-visible"
                )}
              >
                <Grid container spacing={2}>
                  {filteredData?.length === 0 && (
                    <h1 className={`${classes.textColor}`}>No data...</h1>
                  )}
                  {filteredData?.map((item, index) => {
                    const phone = getOrgContactList(item?.contact, langId)[0] || "";
                    return (
                    <Grid item xs={12} md={6} key={index}>
                      <div
                        className={clsx(
                          "p-3 rounded-xl flex justify-between items-center cursor-pointer gap-3",
                          classes.emergencyBg,
                          isEnglish ? "flex-row" : "flex-row-reverse"
                        )}
                        onClick={() => {
                          setItem(item);
                          setOpenItem(true);
                        }}
                      >
                        <div className="flex flex-col min-w-0 flex-1">
                          <Typography
                            variant="p"
                            color={"white"}
                            className={`font-bold ${
                              isEnglish ? "text-left" : "text-right"
                            }`}
                          >
                            {getTextFromTranslation(item?.title)}
                          </Typography>
                          {phone ? (
                            <Typography
                              variant="p"
                              color={"white"}
                              className={`font-bold ${
                                isEnglish ? "text-left" : "text-right"
                              }`}
                            >
                              {phone}
                            </Typography>
                          ) : null}
                        </div>
                        {phone ? (
                          <EmergencyPhoneBadge circleColor={colors.primaryDark} />
                        ) : null}
                      </div>
                    </Grid>
                    );
                  })}
                </Grid>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        <ModalAbout open={openAbout} handleClose={handleClose} />
        <ModalEmergency
          open={openItem}
          handleClose={handleCloseItem}
          item={item}
        />
      </div>
    </div>
  );
}

export default ServicesDetail;
